import DisplayWindow from './DisplayWindow';

export default DisplayWindow;
